import styled, { keyframes, css } from "styled-components";

const scroll = () => keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-75%);
  }
`;

export const Container = styled.div`
  width: 100%;
  height: ${(props) => props.height || "200px"};

  position: absolute;
  top: 50px;
  overflow: hidden;
`;

export const MovingContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(props) => props.backgroundColor || "#000"};

  position: absolute;
  padding: 24px;
  animation: ${scroll} 80s linear infinite alternate;

  img {
    margin-right: 96px;
    max-height: 44px;
  } 

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
    padding: 12px;

    img {
      margin-right: 48px;
      max-height: 22px;
    }
  }
`;
